export default __webpack_public_path__ + "static/media/palta-512.c9c4cdf5.svg";